var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.216 13.76L5.28916 1.30572C2.98665 -0.133345 3.18901e-06 1.522 2.95164e-06 4.23723L2.92437e-06 4.54911C2.83538e-06 5.56703 0.358724 6.55238 1.01314 7.33205C6.19138 13.5014 6.19138 22.4986 1.01313 28.6679C0.35872 29.4476 6.6153e-07 30.433 5.72542e-07 31.4509L5.45276e-07 31.7628C3.07903e-07 34.478 2.98665 36.1333 5.28916 34.6943L25.216 22.24C28.3494 20.2817 28.3494 15.7183 25.216 13.76Z",
    fill: "#777272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrow);
export default __webpack_public_path__ + "static/media/nextarrow.665af2812b3e6a1f6b30c145953c3240.svg";
export { ForwardRef as ReactComponent };